export interface AffixShortcutProps {
  newMessageCounts: number;
  markCounts?: number;
  onClick: (type: ShortcutType) => void;
}

export enum ShortcutType {
  MARK = 'MARK',
  DOWN_UP = 'DOWN_UP',
}
